import React from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import { WithMobileContextProps, withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import CloseIcon from '@wix/da-ds/pkg/Icons/generated/components/CloseThin';
import s from './CloseButton.scss';

export interface Props {
  className?: string;
  size?: string;
  onClick?(e?): void;
}

class CloseButton extends React.Component<Props & WithMobileContextProps & WithTranslation> {
  render() {
    const size = this.props.size || (this.props.isMobile ? '1em' : '1.35em');
    return (
      <PlainButtonOrLink
        className={classnames(s['root'], this.props.className)}
        onClick={this.props.onClick}
      >
        <CloseIcon size={size} />
      </PlainButtonOrLink>
    );
  }
}

export default withTranslation()(withMobileContext(CloseButton)) as React.ComponentType<Props>;
